export default {
  deliveryOption: {
    status: 'requireData',
    productPreview: false,
    deliveryGroups: [],
    unshippableGroups: [],
    focusItem: [],
    basketShippable: true,
    blacklistedRegion: false,
    containsElectronicDeliveryOption: false,
  },
};
